import React, {useState, useEffect} from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import MarqueeComponent from '../component/MarqueeComponent'
import { slides } from '../component/data.js'
import Newsletter from '../component/Newsletter.jsx';
import FurnitureShowcase from '../component/FurnitureShowCase.jsx';
import Testimonial from '../component/Testimonial.jsx';
import ShippingSection from '../component/ShippingSection.jsx';
import SwiperSection from '../component/SwiperSection.jsx';
import ProductSection from '../component/ProductSection.jsx';
import VideoSection from '../component/VideoSection.jsx';
import HomepageBlog from '../component/HomepageBlog.jsx';
import WhatsappButton from '../component/WhatsappButton.jsx';
import BannerSection from './BannerSection.jsx';
import APIs from '../redux/apiUrl.js';
import imageOne from '../assets/img/new/product1.jpg'
import imageTwo from '../assets/img/new/product2.jpg'
import imageThree from '../assets/img/new/product3.jpg'

const LandingPage = () => {
  const [marqueeTexts, setMarqueeTexts] = useState([
    'Discover the best interior furniture!',
    'Modern, Stylish, and Affordable!',
    'Shop Now and Elevate Your Space!',
    'Limited Time Offers!',
  ]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMarqueeTexts = async () => {
      try {
        setLoading(true);
        const response = await APIs.get('/get_all_macue/1/10');
        
        if (response.data && response.data.data && response.data.data.docs) {
          
          const texts = response.data.data.docs.map(
            item => item.text || item.content || item.message || item.title
          );
          
          if (texts.length > 0) {
            setMarqueeTexts(texts);
          }
        }
      } catch (error) {
        console.error('Failed to fetch marquee texts:', error);
        // Keep using the default texts if there's an error
      } finally {
        setLoading(false);
      }
    };

    fetchMarqueeTexts();
  }, []);

  return (
    <>
    <section className="hero__slider--section">
        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          autoplay={{ delay: 5000 }}
          navigation
          pagination={{ clickable: true }}
          loop
          className="hero__slider--inner mb-8"
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id} className={`hero__slider--bg ${slide.className}`}>
              <div className="hero__slider--items">
                <div className="container-fluid">
                  <MarqueeComponent texts={marqueeTexts} />
                  <div className="hero__slider--items__inner">
                    <div className="row row-cols-1">
                      <div className="col">
                        <div className="slider__content">
                          <p className="slider__content--desc text-white text-xl mb-15 font-bold">
                            {slide.content.desc}
                          </p>
                          <h2 className="slider__content--maintitle text-white h1">
                            {slide.content.title}
                          </h2>
                          <p className="slider__content--desc text-white mb-35 font-medium text-xl">
                            {slide.content.subDesc}
                          </p>
                          <a
                            className="slider__content--btn primary__button"
                            href={slide.content.link}
                          >
                            Start Buying
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <BannerSection />
      <FurnitureShowcase /> 

      <section class="banner__section section--padding pt-0">
        <div class="container-fluid">
          <div class="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb--n28">
            <div class="col mb-28">
              <div class="banner__items">
                <a
                  class="banner__items--thumbnail position__relative"
                  href="/shop"
                >
                  <img
                    class="banner__items--thumbnail__img"
                    src={imageOne}
                    alt="banner-img"
                  />
                  <div class="banner__items--content__style2 right">
                    <h2 class="banner__items--content__style2--title text-black">
                      Gray Stylish <br />
                      Chair
                    </h2>
                    <span class="banner__items--content__link primary__btn style2">
                      Shop Now
                    </span>
                  </div>
                </a>
              </div>
            </div>
            <div class="col mb-28">
              <div class="banner__items">
                <a
                  class="banner__items--thumbnail position__relative"
                  href="/shop"
                >
                  <img
                    class="banner__items--thumbnail__img"
                    src={imageTwo}
                    alt="banner-img"
                  />
                  <div class="banner__items--content__style2 right">
                    <h2 class="banner__items--content__style2--title text-yellow-400">
                      Black Stylish <br />
                      Chair
                    </h2>
                    <span class="banner__items--content__link primary__btn style2">
                    Shop Now
                    </span>
                  </div>
                </a>
              </div>
            </div>
            <div class="col mb-28">
              <div class="banner__items">
                <a
                  class="banner__items--thumbnail position__relative"
                  href="/shop"
                >
                  <img
                    class="banner__items--thumbnail__img"
                    src={imageThree}
                    alt="banner-img"
                  />
                  <div class="banner__items--content__style2">
                    <h2 class="banner__items--content__style2--title text-black">
                      Purple Stylish <br />
                      Chair
                    </h2>
                    <span class="banner__items--content__link primary__btn style2">
                    Shop Now
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ProductSection />
      <VideoSection />
      <ShippingSection />
      <Testimonial />
      <Newsletter />
      <HomepageBlog />
      <SwiperSection />
      <WhatsappButton /> 
    </>
  );
};

export default LandingPage;
